const ProjectRoutes = {
  getProjectName: 'gpt/project/getName',
  updateProjectName: 'gpt/project/updateName',
  getProjectDetail: 'gpt/project/getdetail',
  updateProject: 'gpt/project/update',
};

export default ProjectRoutes